import { formatFileTimestamp } from "utils/charts/csvMetadata";

const LINE_BREAK = "\r\n";

export type MatrixChartCsvRow = {
    index: number;
    target: number | null;
    measurement: number | null;
    rpm: number | null;
    vel: number | null;
};

const CSV_HEADERS = ["frequency", "target", "measurement", "rpm", "vel"] as const;

const toCsvCell = (value: number | null): string => {
    if (value === null || Number.isNaN(value)) return "";
    return String(value);
};

const sanitizeFilePart = (value: string | null | undefined, fallback: string): string => {
    const normalized = value?.trim();
    if (!normalized) return fallback;
    return normalized.replace(/[^A-Za-z0-9_-]+/g, "_");
};

export const buildChartCsv = (rows: MatrixChartCsvRow[], metaLines: string[] = []): string => {
    const body = rows.map((row) => [
        String(row.index),
        toCsvCell(row.target),
        toCsvCell(row.measurement),
        toCsvCell(row.rpm),
        toCsvCell(row.vel),
    ]);

    return [
        ...metaLines,
        CSV_HEADERS.join(","),
        ...body.map((row) => row.join(",")),
    ].join(LINE_BREAK);
};

export const makeChartCsvFileName = (
    unitId: string | null,
    phenomenonGroupId: string | null,
    conditionId: string,
    now: Date = new Date()
): string => {
    const timestamp = formatFileTimestamp(now);
    const safeUnitId = sanitizeFilePart(unitId, "unit");
    const safeGroupId = sanitizeFilePart(phenomenonGroupId, "group");
    const safeConditionId = sanitizeFilePart(conditionId, "condition");
    // 接頭辞は unit-現象グループ、続けてセル固有の condition（現象-運転モード）で衝突回避。
    return `${safeUnitId}-${safeGroupId}_${safeConditionId}_${timestamp}.csv`;
};
